import VueClickOutside from 'vue-click-outside'

export default {
    install: function (Vue) {
        Vue.directive('click-outside', VueClickOutside)
    }
}